import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Navigation } from '@/components/navigation'
import { Footer } from '@/components/footer'
import { SessionProvider } from '@/components/session'
import { NotificationProvider } from '@/components/notifications'
import { PreferencesProvider } from '@/hooks/usePreferences'
import { ErrorBoundary } from '@/components/error'
import { TradeRoom } from '@/screens/TradeRoom'
import { AccountManagement } from '@/screens/AccountManagement'
import { PortfolioManagement } from '@/screens/PortfolioManagement'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
      retry: 3,
    },
  },
})

function App() {
  // Session event handlers
  const handleSessionWarning = () => {
    // You can customize this to show a notification or modal
    // Example: Show a notification toast
    // showNotification('warning', 'Session expires in 5 minutes');
  };

  const handleSessionExpiry = () => {
    // You can customize this to show a message or redirect
    // Example: Show a notification and redirect to login
    // showNotification('error', 'Session expired. Please login again.');
    // window.location.href = '/login';
  };

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider 
        onSessionWarning={handleSessionWarning}
        onSessionExpiry={handleSessionExpiry}
      >
        <NotificationProvider>
          <PreferencesProvider>
            <ErrorBoundary>
              <Router>
              <div className="app">
                <Navigation />
                <main className="main-content">
                  <Routes>
                    <Route path="/" element={<TradeRoom />} />
                    <Route path="/trade" element={<TradeRoom />} />
                    <Route path="/account" element={<AccountManagement />} />
                    <Route path="/portfolio" element={<PortfolioManagement />} />
                  </Routes>
                </main>
                <Footer />
              </div>
              </Router>
            </ErrorBoundary>
          </PreferencesProvider>
        </NotificationProvider>
      </SessionProvider>
    </QueryClientProvider>
  )
}

export default App
